const U = (id, w = 1200) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
  heroBowl: U("photo-1626777552726-4a6b54c97e46", 1400),
  catBreakfast: U("photo-1668236543090-82eba5ee5976", 900),
  catLunch: U("photo-1589302168068-964664d93dc0", 900),
  catCorporate: U("photo-1577219491135-ce391730fb2c", 900),
  corporateCard: U("photo-1546069901-ba9599a7e63c", 900),
  cateringCard: U("photo-1600565193348-f74bd3c7ccdf", 900),
  story: U("photo-1566554273541-37a9ca77b91f", 1200),
  spices: U("photo-1615485500834-bc10199bc727", 900),
  sweets: U("photo-1784902540665-f6ab6dfef921", 900),
  drinks: U("photo-1571934811356-5cc061b6821f", 900),
  fingerFood: U("photo-1601050690597-df0568f70950", 900),
  soup: U("photo-1547592166-23ac45744acd", 900),
};

export const FAVOURITES = [
  { name: { en: "Aloo Paratha", pl: "Paratha aloo" }, price: "PLN 15", img: U("photo-1567188040759-fb8a883dc6d8", 700) },
  { name: { en: "Chicken Biryani", pl: "Biryani z kurczakiem" }, price: "PLN 42", img: U("photo-1589302168068-964664d93dc0", 700) },
  { name: { en: "Rajma & Rice", pl: "Rajma z ryżem" }, price: "PLN 30", img: U("photo-1565557623262-b51c2513a641", 700) },
  { name: { en: "Grilled Chicken Salad", pl: "Sałatka z grillowanym kurczakiem" }, price: "PLN 30", img: U("photo-1512621776951-a57141f2eefd", 700) },
  { name: { en: "Masala Tea", pl: "Masala chai" }, price: "PLN 10", img: U("photo-1571934811356-5cc061b6821f", 700) },
];

export const BREAKFAST_ITEMS = [
  {
    id: "aloo-paratha-tea",
    name: { en: "Aloo Paratha + Indian Tea", pl: "Paratha aloo + herbata indyjska" },
    desc: { en: "Potato-stuffed paratha, crisped on the tawa, with spiced Indian tea.", pl: "Paratha z nadzieniem ziemniaczanym, chrupiąca z tawy, z przyprawioną herbatą." },
    price: "PLN 26",
    img: U("photo-1567188040759-fb8a883dc6d8", 400),
  },
  {
    id: "paneer-paratha-tea",
    name: { en: "Paneer Paratha + Indian Tea", pl: "Paratha paneer + herbata indyjska" },
    desc: { en: "Fresh paneer filling, ghee finish, hot masala tea.", pl: "Nadzienie ze świeżego paneeru, finisz ghee, gorąca masala chai." },
    price: "PLN 28",
    img: U("photo-1601050690597-df0568f70950", 400),
  },
  {
    id: "mixed-paratha-tea",
    name: { en: "Mixed Paratha + Indian Tea", pl: "Paratha mieszana + herbata indyjska" },
    desc: { en: "Vegetable and paneer mixed stuffing, served with Indian tea.", pl: "Mieszane nadzienie warzywno-paneerowe, podawane z herbatą." },
    price: "PLN 28",
    img: U("photo-1630383249896-424e482df921", 400),
  },
  {
    id: "bread-omelette-tea",
    name: { en: "Bread Omelette + Indian Tea", pl: "Omlet w chlebie + herbata indyjska" },
    desc: { en: "Street-style masala omelette folded into toasted bread.", pl: "Uliczny omlet masala złożony w opiekane pieczywo." },
    price: "PLN 22",
    img: U("photo-1510693206972-df098062cb71", 400),
  },
  {
    id: "plain-paratha-veg",
    name: { en: "Plain Paratha + Vegetables", pl: "Paratha naturalna + warzywa" },
    desc: { en: "Flaky paratha with a spiced seasonal vegetable stir-fry.", pl: "Warstwowa paratha z przyprawionymi warzywami sezonowymi." },
    price: "PLN 24",
    img: U("photo-1784902540665-f6ab6dfef921", 400),
  },
  {
    id: "moong-dal-chilla",
    name: { en: "Protein Moong Dal Chilla", pl: "Proteinowa chilla z mung dal" },
    desc: { en: "Savoury lentil pancake — high protein, griddled crisp.", pl: "Wytrawny naleśnik soczewicowy — bogaty w białko, chrupiący." },
    price: "PLN 26",
    img: U("photo-1668236543090-82eba5ee5976", 400),
  },
  {
    id: "egg-bhurji-roti",
    name: { en: "Masala Egg Bhurji + Tawa Roti", pl: "Masala bhurji z jajek + tawa roti" },
    desc: { en: "Scrambled eggs with onion, tomato and chili. Tea or coffee included.", pl: "Jajecznica z cebulą, pomidorem i chili. Herbata lub kawa w cenie." },
    price: "PLN 28",
    img: U("photo-1565557623262-b51c2513a641", 400),
  },
  {
    id: "paneer-bhurji-roti",
    name: { en: "Paneer Bhurji + Roti + Tea", pl: "Bhurji z paneerem + roti + herbata" },
    desc: { en: "Crumbled paneer scramble with peppers and masala, tawa roti.", pl: "Rozkruszony paneer z papryką i masalą, tawa roti." },
    price: "PLN 28",
    img: U("photo-1631452180519-c014fe946bc7", 400),
  },
  {
    id: "sprouts-chaat-bowl",
    name: { en: "Sprouts Chaat Breakfast Bowl", pl: "Śniadaniowa misa chaat z kiełkami" },
    desc: { en: "Moong and chana sprouts, vegetables, paneer, lemon and herbs.", pl: "Kiełki mung i cieciorki, warzywa, paneer, cytryna i zioła." },
    price: "PLN 24",
    img: U("photo-1610192244261-3f33de3f55e4", 400),
  },
  {
    id: "protein-box",
    name: { en: "Indian Breakfast Protein Box", pl: "Indyjskie pudełko proteinowe" },
    desc: { en: "Two boiled eggs, paneer, roti, fruit, cucumber and tomato.", pl: "Dwa jajka na twardo, paneer, roti, owoce, ogórek i pomidor." },
    price: "PLN 32",
    img: U("photo-1546069901-ba9599a7e63c", 400),
  },
];

export const LUNCH_ITEMS = [
  {
    id: "chicken-biryani",
    name: { en: "Chicken Biryani", pl: "Biryani z kurczakiem" },
    desc: { en: "Aromatic basmati layered with tender chicken and saffron.", pl: "Aromatyczny basmati z delikatnym kurczakiem i szafranem." },
    price: "PLN 42",
    img: U("photo-1589302168068-964664d93dc0", 700),
  },
  {
    id: "mutton-biryani",
    name: { en: "Mutton Biryani", pl: "Biryani z jagnięciną" },
    desc: { en: "Slow-cooked mutton, whole spices, long-grain basmati.", pl: "Powoli gotowana jagnięcina, całe przyprawy, basmati." },
    price: "PLN 48",
    img: U("photo-1585937421612-70a008356fbe", 700),
  },
  {
    id: "veg-biryani",
    name: { en: "Veg Biryani", pl: "Biryani warzywne" },
    desc: { en: "Seasonal vegetables, fried onions, mint and saffron rice.", pl: "Warzywa sezonowe, smażona cebula, mięta i szafranowy ryż." },
    price: "PLN 36",
    img: U("photo-1546069901-ba9599a7e63c", 700),
  },
  {
    id: "fried-rice",
    name: { en: "Fried Rice — Egg / Chicken", pl: "Ryż smażony — jajko / kurczak" },
    desc: { en: "Wok-tossed rice with egg or chicken, spring onion.", pl: "Ryż z woka z jajkiem lub kurczakiem, szczypiorek." },
    price: "PLN 34",
    img: U("photo-1606491956689-2ea866880c84", 700),
  },
  {
    id: "rajma-rice",
    name: { en: "Rajma & Rice", pl: "Rajma z ryżem" },
    desc: { en: "Kidney beans simmered in tomato-ginger masala, with rice.", pl: "Czerwona fasola w sosie pomidorowo-imbirowym, z ryżem." },
    price: "PLN 30",
    img: U("photo-1565557623262-b51c2513a641", 700),
  },
  {
    id: "chole-rice",
    name: { en: "Chole & Rice", pl: "Chole z ryżem" },
    desc: { en: "Chickpeas in a tangy amchur masala, steamed rice.", pl: "Cieciorka w kwaśnej masali amchur, ryż na parze." },
    price: "PLN 30",
    img: U("photo-1631452180519-c014fe946bc7", 700),
  },
  {
    id: "dal-rice-veg",
    name: { en: "Dal, Rice & Vegetables", pl: "Dal z ryżem i warzywami" },
    desc: { en: "Yellow dal tadka, rice and the seasonal vegetable of the day.", pl: "Żółty dal tadka, ryż i warzywo sezonowe dnia." },
    price: "PLN 30",
    img: U("photo-1596797038530-2c107229654b", 700),
  },
  {
    id: "grilled-chicken-salad",
    name: { en: "Grilled Chicken Salad", pl: "Sałatka z grillowanym kurczakiem" },
    desc: { en: "Tandoori-spiced chicken over crunchy greens and grains.", pl: "Kurczak w przyprawach tandoori na chrupiącej zieleninie." },
    price: "PLN 30",
    img: U("photo-1512621776951-a57141f2eefd", 700),
  },
];

export const SWEET_ITEMS = [
  { id: "gulab-jamun", name: { en: "Gulab Jamun", pl: "Gulab Jamun" }, desc: { en: "Milk dumplings soaked in rose-cardamom syrup, served warm.", pl: "Mleczne kulki moczone w syropie różano-kardamonowym, na ciepło." }, price: "PLN 16" },
  { id: "rasgulla", name: { en: "Rasgulla", pl: "Rasgulla" }, desc: { en: "Feather-light cheese balls in chilled saffron syrup.", pl: "Lekkie kulki serowe w schłodzonym szafranowym syropie." }, price: "PLN 16" },
  { id: "rasmalai", name: { en: "Rasmalai", pl: "Rasmalai" }, desc: { en: "Soft paneer discs in saffron-pistachio milk.", pl: "Miękkie krążki paneer w szafranowo-pistacjowym mleku." }, price: "PLN 18" },
  { id: "suji-halwa", name: { en: "Suji Halwa", pl: "Suji Halwa" }, desc: { en: "Warm semolina pudding with ghee, cardamom and toasted nuts.", pl: "Ciepły budyń z kaszy manny z ghee, kardamonem i orzechami." }, price: "PLN 14" },
  { id: "gajar-halwa", name: { en: "Gajar Halwa", pl: "Gajar Halwa" }, desc: { en: "Slow-cooked carrot halwa — winter's answer to everything.", pl: "Powoli gotowana halwa marchewkowa — zimowa odpowiedź na wszystko." }, price: "PLN 16" },
  { id: "kheer", name: { en: "Kheer", pl: "Kheer" }, desc: { en: "Silky rice pudding with cardamom and almonds.", pl: "Kremowy pudding ryżowy z kardamonem i migdałami." }, price: "PLN 14" },
  { id: "mathura-kulfi", name: { en: "Mathura Kulfi", pl: "Kulfi z Mathury" }, desc: { en: "Dense, hand-churned kulfi — Mathura style.", pl: "Gęste, ręcznie ubijane kulfi — w stylu z Mathury." }, price: "PLN 15" },
];

export const MENU_CATEGORIES = [
  {
    id: "rice",
    label: { en: "Rice", pl: "Ryż" },
    items: [
      { name: { en: "Chicken Biryani", pl: "Biryani z kurczakiem" }, price: "PLN 42" },
      { name: { en: "Mutton Biryani", pl: "Biryani z jagnięciną" }, price: "PLN 48" },
      { name: { en: "Veg Biryani", pl: "Biryani warzywne" }, price: "PLN 36" },
      { name: { en: "Plain Rice", pl: "Ryż naturalny" }, price: "PLN 12" },
      { name: { en: "Fried Rice — Egg / Chicken", pl: "Ryż smażony — jajko / kurczak" }, price: "PLN 34" },
      { name: { en: "Rajma & Rice", pl: "Rajma z ryżem" }, price: "PLN 30" },
      { name: { en: "Chole & Rice", pl: "Chole z ryżem" }, price: "PLN 30" },
      { name: { en: "Dal, Rice & Vegetables", pl: "Dal z ryżem i warzywami" }, price: "PLN 30" },
    ],
  },
  {
    id: "roti",
    label: { en: "Roti & Naan", pl: "Roti i naan" },
    items: [
      { name: { en: "Plain Tawa Roti", pl: "Tawa roti" }, price: "PLN 6" },
      { name: { en: "Tandoori Roti", pl: "Tandoori roti" }, price: "PLN 7" },
      { name: { en: "Garlic Roti", pl: "Roti czosnkowe" }, price: "PLN 9" },
      { name: { en: "Plain Naan", pl: "Naan" }, price: "PLN 10" },
      { name: { en: "Garlic Naan", pl: "Naan czosnkowy" }, price: "PLN 12" },
      { name: { en: "Kashmiri Naan", pl: "Naan kaszmirski" }, price: "PLN 14" },
      { name: { en: "Aloo Paratha", pl: "Paratha aloo" }, price: "PLN 15" },
      { name: { en: "Paneer Paratha", pl: "Paratha paneer" }, price: "PLN 17" },
    ],
  },
  {
    id: "salads",
    label: { en: "Grilled Salads", pl: "Sałatki z grilla" },
    items: [
      { name: { en: "Grilled Mango Salad", pl: "Sałatka z grillowanym mango" }, price: "PLN 26" },
      { name: { en: "Grilled Paneer Salad", pl: "Sałatka z grillowanym paneerem" }, price: "PLN 28" },
      { name: { en: "Grilled Chicken Salad", pl: "Sałatka z grillowanym kurczakiem" }, price: "PLN 30" },
      { name: { en: "Grilled Prawns Salad", pl: "Sałatka z grillowanymi krewetkami" }, price: "PLN 36" },
    ],
  },
  {
    id: "soups",
    label: { en: "Soups", pl: "Zupy" },
    items: [
      { name: { en: "Tomato Soup", pl: "Zupa pomidorowa" }, price: "PLN 18" },
      { name: { en: "Chicken Soup", pl: "Zupa z kurczakiem" }, price: "PLN 22" },
      { name: { en: "Mutton Soup", pl: "Zupa z jagnięciny" }, price: "PLN 26" },
      { name: { en: "Tom Yum Soup", pl: "Zupa tom yum" }, price: "PLN 24" },
      { name: { en: "Dal Soup", pl: "Zupa dal" }, price: "PLN 18" },
    ],
  },
  {
    id: "drinks",
    label: { en: "Drinks", pl: "Napoje" },
    items: [
      { name: { en: "Masala Tea", pl: "Masala chai" }, price: "PLN 10" },
      { name: { en: "Ginger Tea", pl: "Herbata imbirowa" }, price: "PLN 10" },
      { name: { en: "Lemon Tea", pl: "Herbata cytrynowa" }, price: "PLN 9" },
      { name: { en: "Lemon Juice", pl: "Sok z cytryny" }, price: "PLN 12" },
      { name: { en: "Mango Lassi", pl: "Mango lassi" }, price: "PLN 14" },
      { name: { en: "Banana Protein Shake", pl: "Koktajl proteinowy bananowy" }, price: "PLN 18" },
      { name: { en: "Seasonal Shake", pl: "Koktajl sezonowy" }, price: "PLN 16" },
      { name: { en: "Water", pl: "Woda" }, price: "PLN 6" },
      { name: { en: "Coke", pl: "Coca-Cola" }, price: "PLN 8" },
      { name: { en: "Pepsi", pl: "Pepsi" }, price: "PLN 8" },
    ],
  },
];

export const CONTENT = {
  en: {
    nav: { home: "Home", menu: "Menu", breakfast: "Breakfast", lunch: "Lunch", sweets: "Sweets", catering: "Catering", story: "Our Story", contact: "Contact" },
    orderNow: "Order Now",
    orderVia: "Order via",
    hero: {
      title1: "AI-Powered Healthy",
      title2: "Indian Breakfast & Lunch",
      sub: "Authentic Indian food for modern Warsaw. Fresh, healthy, balanced and full of flavour.",
      cta2: "Corporate Lunch",
    },
    features: [
      { t: "Healthy & Balanced", d: "Meals designed for every day" },
      { t: "Authentic Indian Flavours", d: "Heritage recipes, real spices" },
      { t: "Office & Corporate Lunch", d: "Delivered to your workplace" },
      { t: "Catering & Events", d: "From 10 to 200+ people" },
    ],
    categories: [
      {
        id: "breakfast",
        title: "Indian Breakfast",
        desc: "Start your day with a healthy Indian breakfast.",
        bullets: ["Paratha · Poha · Upma · Idli", "Masala Omelette · Chai · Lassi"],
        cta: "View Breakfast Menu",
      },
      {
        id: "lunch",
        title: "Daily Indian Lunch",
        desc: "Freshly prepared Indian meals for lunch.",
        bullets: ["Biryani · Curries · Dal · Rice", "Roti · Paneer · Chicken · Salads"],
        cta: "View Lunch Menu",
      },
      {
        id: "corporate",
        title: "Corporate Lunch",
        desc: "Healthy Indian meals delivered directly to your office.",
        bullets: ["Individual boxes · Team orders", "Weekly/Monthly plans · Custom menus"],
        cta: "Corporate Lunch",
      },
    ],
    why: {
      title: "Why Kurkuma?",
      sub: "Indian food made for modern Warsaw.",
      items: [
        { t: "Fresh Every Day", d: "No long-term storage, just fresh ingredients." },
        { t: "Less Oil", d: "Balanced, healthy Indian meals." },
        { t: "Veg & Non-Veg", d: "Options for every preference." },
        { t: "Office Friendly", d: "Perfect portions for lunch breaks." },
        { t: "AI Powered", d: "Smarter planning, less food waste." },
        { t: "Made for Warsaw", d: "Fast delivery & corporate solutions." },
      ],
    },
    favourites: { title: "Our Favourite Dishes", sub: "A taste of India, made fresh for you.", viewAll: "View Full Menu" },
    corporate: {
      title: "Corporate Lunch Program",
      sub: "Healthy Indian meals for your team.",
      checks: ["Daily delivery to your office", "Flexible plans (10+ meals)", "Vegetarian & non-vegetarian options", "Custom corporate menus"],
      cta: "Get Corporate Offer",
    },
    cateringCard: {
      title: "Catering for Every Occasion",
      sub: "From 10 to 200+ people.",
      checks: ["Corporate events", "Business meetings", "Private parties", "Weddings & celebrations"],
      cta: "Get Catering Quote",
    },
    delivery: {
      title: "Delivery Areas",
      areas: ["Ursus", "Wola", "Ochota", "Mokotów", "Śródmieście", "Nearby areas"],
      city: "Warsaw",
      cta: "Check Delivery Area",
    },
    platforms: [
      { id: "glovo", name: "Glovo", url: "https://glovoapp.com" },
      { id: "wolt", name: "Wolt", url: "https://wolt.com" },
      { id: "ubereats", name: "Uber Eats", url: "https://www.ubereats.com/pl" },
      { id: "pyszne", name: "Pyszne.pl", url: "https://www.pyszne.pl" },
      { id: "bolt", name: "Bolt Food", url: "https://food.bolt.eu" },
    ],
    promo: {
      kicker: "Limited Promotion",
      big: "−25%",
      line: "For students & delivery riders",
      body: "Flash your student card or rider app when you order. The people who keep this city moving deserve the good rice.",
      codeLabel: "Use code",
      code: "KURKUMA25",
      note: "Tap to copy · valid on all platforms",
    },
    promoBday: {
      kicker: "Birthdays at Kurkuma",
      big: "−25%",
      line: "On your birthday",
      body: "Celebrate your birthday with us — order on the day, show your ID, and make it a happier one.",
      codeLabel: "Use code",
      code: "BDAY25",
      note: "Valid on your birthday · ID required",
    },
    promoOpen: {
      kicker: "Grand Opening",
      big: "DEC–JAN",
      line: "Opening soon in Warsaw",
      body: "We're firing up the tandoor this winter. Be first in line — follow us for the exact date and opening-day offers.",
      note: "Warsaw · Poland · Winter 2026/27",
      countdown: true,
      countdownLabels: { d: "DAYS", h: "HOURS", m: "MIN", s: "SEC" },
      offer: {
        locked: "Unlocks on opening day: −25% + free sweet + mango lassi",
        big: "−25%",
        line: "Opening Day Offer",
        body: "We're open! Today only: 25% off your order, plus a free sweet and a mango lassi with every meal.",
        perks: ["25% off everything", "Free sweet of the day", "Free mango lassi"],
        codeLabel: "Use code",
        code: "OPENING25",
        note: "Opening day only · Warsaw",
      },
    },
    announce: "OPENING SOON · DECEMBER–JANUARY · WARSAW",
    footer: {
      tagline: "AI-Powered Healthy Indian Breakfast & Lunch",
      explore: "Explore",
      orderCol: "Order",
      orderLinks: ["Order Online", "Corporate Order", "Catering Quote", "Delivery"],
      contactCol: "Contact",
      address: "7/11 Posing St., 00-124 Warsaw, Poland",
      email: "info@thekurkuma.pl",
      phone: "+48 666 012 783",
      newsletterTitle: "Get this week's menu",
      newsletterPh: "Your email address",
      subscribe: "Subscribe",
      subscribed: "Subscribed! See you in your inbox.",
      rights: "© 2026 The Kurkuma AI Kitchen. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms",
    },
    breakfastPage: { title: "Breakfast Menu", sub: "Traditional Indian breakfast, fresh and healthy.", hours: "DAILY 07:30–11:00" },
    lunchPage: {
      title: "Lunch Menu",
      sub: "Fresh, flavourful and wholesome.",
      hours: "DAILY 11:00–16:30",
      howTitle: "How It Works",
      steps: [
        { t: "Choose your menu", d: "Select breakfast, lunch or both" },
        { t: "Tell us your office address", d: "We confirm delivery details" },
        { t: "Select delivery time", d: "We deliver at your convenience" },
        { t: "Your team enjoys", d: "Fresh, healthy, delicious meals" },
      ],
      perfectTitle: "Perfect for",
      perfect: ["Corporate Offices", "IT Companies", "Business Parks", "Team Lunches"],
    },
    sweetsPage: { title: "Indian Sweets", sub: "Slow milk, saffron, cardamom. Small batches, made fresh daily.", note: "PRICES IN PLN · MADE DAILY" },
    menuPage: {
      title: "Full Menu",
      sub: "All our dishes in one place.",
      tabs: { breakfast: "Breakfast", lunch: "Lunch", sweets: "Sweets", drinks: "Drinks" },
      itemsWord: "items",
    },
    cateringPage: {
      heroTitle: "Catering",
      heroSub: "Indian food for every occasion.",
      servicesTitle: "Our Catering Services",
      services: [
        { t: "Corporate Events", d: "Meetings, conferences, workshops" },
        { t: "Private Events", d: "Birthdays, house parties, celebrations" },
        { t: "Full Buffet", d: "Starters · Main course · Rice · Bread · Salad · Dessert" },
      ],
      packagesTitle: "Catering Packages",
      packages: [
        { t: "Breakfast Catering", d: "Paratha · Poha · Upma · Idli · Chai" },
        { t: "Lunch Catering", d: "Rice · Curry · Paneer · Chicken" },
        { t: "Indian Finger Food", d: "Samosa · Pakora · Tikka" },
      ],
      buffet: { t: "Full Indian Buffet", d: "From 10 to 200+ people", cta: "Get Catering Quote" },
    },
    storyPage: {
      heroTitle: "Our Story",
      heroSub: "From India to Warsaw.",
      paras: [
        "The Kurkuma AI Kitchen was created for people who love Indian food but want something fresh, balanced and convenient for everyday life.",
        "Inspired by Indian home cooking and built for modern Warsaw, Kurkuma combines traditional recipes with modern technology.",
        "From your morning chai and paratha to your office lunch — our goal is simple: make Indian food part of your everyday life.",
      ],
      motto: "Real Food, Better Tomorrow",
      values: ["Tradition", "Freshness", "Technology", "You"],
    },
    contactPage: {
      heroTitle: "Contact Us",
      heroSub: "We'd love to hear from you.",
      visit: "Visit Us",
      emailUs: "Email Us",
      callUs: "Call Us",
      followUs: "Follow Us",
      form: {
        title: "Send us a message",
        name: "Name *",
        email: "Email *",
        company: "Company",
        phone: "Phone",
        date: "Event date",
        guests: "Guest count",
        budget: "Budget range",
        budgets: ["Under 1,000 PLN", "1,000–3,000 PLN", "3,000–10,000 PLN", "10,000+ PLN"],
        message: "Message *",
        send: "Send Message",
        sending: "Sending…",
        success: "Message sent. We reply within 24 hours.",
        error: "Could not send — write to info@thekurkuma.pl",
      },
      touchTitle: "Get in Touch for",
      touch: ["Corporate Orders", "Catering Quotes", "General Enquiries"],
      mapTitle: "Warsaw",
    },
  },
  pl: {
    nav: { home: "Start", menu: "Menu", breakfast: "Śniadania", lunch: "Lunch", sweets: "Desery", catering: "Catering", story: "O nas", contact: "Kontakt" },
    orderNow: "Zamów teraz",
    orderVia: "Zamów przez",
    hero: {
      title1: "Zdrowe indyjskie jedzenie",
      title2: "Śniadania i lunche z AI",
      sub: "Autentyczna kuchnia indyjska dla nowoczesnej Warszawy. Świeża, zdrowa, zbalansowana i pełna smaku.",
      cta2: "Lunch firmowy",
    },
    features: [
      { t: "Zdrowo i zbalansowanie", d: "Posiłki na co dzień" },
      { t: "Autentyczne indyjskie smaki", d: "Receptury dziadów, prawdziwe przyprawy" },
      { t: "Lunch do biur", d: "Dostawa prosto do pracy" },
      { t: "Catering i wydarzenia", d: "Od 10 do 200+ osób" },
    ],
    categories: [
      {
        id: "breakfast",
        title: "Śniadanie indyjskie",
        desc: "Zacznij dzień zdrowym indyjskim śniadaniem.",
        bullets: ["Paratha · Poha · Upma · Idli", "Omlet masala · Chai · Lassi"],
        cta: "Zobacz menu śniadaniowe",
      },
      {
        id: "lunch",
        title: "Codzienny lunch indyjski",
        desc: "Świeżo przygotowane indyjskie posiłki na lunch.",
        bullets: ["Biryani · Curry · Dal · Ryż", "Roti · Paneer · Kurczak · Sałatki"],
        cta: "Zobacz menu lunchowe",
      },
      {
        id: "corporate",
        title: "Lunch firmowy",
        desc: "Zdrowe indyjskie posiłki z dostawą prosto do biura.",
        bullets: ["Boxy indywidualne · Zamówienia zespołowe", "Plany tygodniowe/miesięczne · Menu na życzenie"],
        cta: "Lunch firmowy",
      },
    ],
    why: {
      title: "Dlaczego Kurkuma?",
      sub: "Indyjskie jedzenie dla nowoczesnej Warszawy.",
      items: [
        { t: "Świeże codziennie", d: "Bez magazynowania — tylko świeże składniki." },
        { t: "Mniej oleju", d: "Zbalansowane, zdrowe indyjskie posiłki." },
        { t: "Wege i mięsne", d: "Opcje dla każdego." },
        { t: "Idealne do biura", d: "Porcje idealne na przerwę lunchową." },
        { t: "Napędzane AI", d: "Mądrzejsze planowanie, mniej marnowania." },
        { t: "Dla Warszawy", d: "Szybka dostawa i rozwiązania firmowe." },
      ],
    },
    favourites: { title: "Nasze ulubione dania", sub: "Smak Indii, świeży dla Ciebie.", viewAll: "Zobacz pełne menu" },
    corporate: {
      title: "Program lunchowy dla firm",
      sub: "Zdrowe indyjskie posiłki dla Twojego zespołu.",
      checks: ["Codzienna dostawa do biura", "Elastyczne plany (10+ posiłków)", "Opcje wegetariańskie i mięsne", "Menu firmowe na życzenie"],
      cta: "Otrzymaj ofertę firmową",
    },
    cateringCard: {
      title: "Catering na każdą okazję",
      sub: "Od 10 do 200+ osób.",
      checks: ["Wydarzenia firmowe", "Spotkania biznesowe", "Przyjęcia prywatne", "Wesela i uroczystości"],
      cta: "Otrzymaj wycenę cateringu",
    },
    delivery: {
      title: "Obszary dostawy",
      areas: ["Ursus", "Wola", "Ochota", "Mokotów", "Śródmieście", "Okoliczne dzielnice"],
      city: "Warszawa",
      cta: "Sprawdź obszar dostawy",
    },
    platforms: [
      { id: "glovo", name: "Glovo", url: "https://glovoapp.com" },
      { id: "wolt", name: "Wolt", url: "https://wolt.com" },
      { id: "ubereats", name: "Uber Eats", url: "https://www.ubereats.com/pl" },
      { id: "pyszne", name: "Pyszne.pl", url: "https://www.pyszne.pl" },
      { id: "bolt", name: "Bolt Food", url: "https://food.bolt.eu" },
    ],
    promo: {
      kicker: "Promocja limitowana",
      big: "−25%",
      line: "Dla studentów i kurierów",
      body: "Pokaż legitymację studencką lub aplikację kuriera przy zamówieniu. Ludzie, którzy utrzymują to miasto w ruchu, zasługują na dobry ryż.",
      codeLabel: "Użyj kodu",
      code: "KURKUMA25",
      note: "Dotknij, aby skopiować · działa na wszystkich platformach",
    },
    promoBday: {
      kicker: "Urodziny z Kurkumą",
      big: "−25%",
      line: "W Twoje urodziny",
      body: "Świętuj urodziny z nami — zamów w tym dniu, pokaż dokument i zrób je jeszcze szczęśliwszymi.",
      codeLabel: "Użyj kodu",
      code: "BDAY25",
      note: "W dniu urodzin · wymagany dokument",
    },
    promoOpen: {
      kicker: "Wielkie otwarcie",
      big: "GRU–STY",
      line: "Wkrótce otwarcie w Warszawie",
      body: "Tandoor rozpalamy tej zimy. Bądź pierwszy w kolejce — obserwuj nas po dokładną datę i oferty na dzień otwarcia.",
      note: "Warszawa · Polska · Zima 2026/27",
      countdown: true,
      countdownLabels: { d: "DNI", h: "GODZ", m: "MIN", s: "SEK" },
      offer: {
        locked: "Odblokuje się w dniu otwarcia: −25% + darmowy deser + mango lassi",
        big: "−25%",
        line: "Oferta dnia otwarcia",
        body: "Otwarci! Tylko dziś: 25% zniżki na zamówienie, a do każdego posiłku darmowy deser i mango lassi.",
        perks: ["25% zniżki na wszystko", "Darmowy deser dnia", "Darmowe mango lassi"],
        codeLabel: "Użyj kodu",
        code: "OPENING25",
        note: "Tylko w dniu otwarcia · Warszawa",
      },
    },
    announce: "WKRÓTCE OTWARCIE · GRUDZIEŃ–STYCZEŃ · WARSZAWA",
    footer: {
      tagline: "Zdrowe indyjskie śniadania i lunche napędzane AI",
      explore: "Odkryj",
      orderCol: "Zamów",
      orderLinks: ["Zamów online", "Zamówienie firmowe", "Wycena cateringu", "Dostawa"],
      contactCol: "Kontakt",
      address: "ul. Posing 7/11, 00-124 Warszawa",
      email: "info@thekurkuma.pl",
      phone: "+48 666 012 783",
      newsletterTitle: "Menu tego tygodnia na e-mail",
      newsletterPh: "Twój adres e-mail",
      subscribe: "Zapisz się",
      subscribed: "Zapisano! Do zobaczenia w skrzynce.",
      rights: "© 2026 The Kurkuma AI Kitchen. Wszelkie prawa zastrzeżone.",
      privacy: "Prywatność",
      terms: "Regulamin",
    },
    breakfastPage: { title: "Menu śniadaniowe", sub: "Tradycyjne indyjskie śniadanie, świeże i zdrowe.", hours: "CODZIENNIE 07:30–11:00" },
    lunchPage: {
      title: "Menu lunchowe",
      sub: "Świeże, pełne smaku i pożywne.",
      hours: "CODZIENNIE 11:00–16:30",
      howTitle: "Jak to działa",
      steps: [
        { t: "Wybierz menu", d: "Śniadanie, lunch lub oba" },
        { t: "Podaj adres biura", d: "Potwierdzamy szczegóły dostawy" },
        { t: "Wybierz godzinę dostawy", d: "Dostarczamy, kiedy Ci pasuje" },
        { t: "Zespół zajada", d: "Świeże, zdrowe, pyszne posiłki" },
      ],
      perfectTitle: "Idealne dla",
      perfect: ["Biur firmowych", "Firm IT", "Parków biznesowych", "Lunchy zespołowych"],
    },
    sweetsPage: { title: "Indyjskie słodycze", sub: "Powolne mleko, szafran, kardamon. Małe partie, robione codziennie.", note: "CENY W PLN · CODZIENNIE ŚWIEŻE" },
    menuPage: {
      title: "Pełne menu",
      sub: "Wszystkie nasze dania w jednym miejscu.",
      tabs: { breakfast: "Śniadania", lunch: "Lunch", sweets: "Desery", drinks: "Napoje" },
      itemsWord: "pozycji",
    },
    cateringPage: {
      heroTitle: "Catering",
      heroSub: "Indyjskie jedzenie na każdą okazję.",
      servicesTitle: "Nasze usługi cateringowe",
      services: [
        { t: "Wydarzenia firmowe", d: "Spotkania, konferencje, warsztaty" },
        { t: "Wydarzenia prywatne", d: "Urodziny, domówki, uroczystości" },
        { t: "Pełne bufety", d: "Przystawki · Dania główne · Ryż · Chleb · Sałatka · Deser" },
      ],
      packagesTitle: "Pakiety cateringowe",
      packages: [
        { t: "Catering śniadaniowy", d: "Paratha · Poha · Upma · Idli · Chai" },
        { t: "Catering lunchowy", d: "Ryż · Curry · Paneer · Kurczak" },
        { t: "Indyjskie finger food", d: "Samosa · Pakora · Tikka" },
      ],
      buffet: { t: "Pełny indyjski bufet", d: "Od 10 do 200+ osób", cta: "Otrzymaj wycenę" },
    },
    storyPage: {
      heroTitle: "Nasza historia",
      heroSub: "Z Indii do Warszawy.",
      paras: [
        "Kurkuma AI Kitchen powstała dla ludzi, którzy kochają kuchnię indyjską, ale na co dzień szukają czegoś świeżego, zbalansowanego i wygodnego.",
        "Zainspirowani indyjskim domowym gotowaniem, zbudowani dla nowoczesnej Warszawy — łączymy tradycyjne receptury z nowoczesną technologią.",
        "Od porannego chai z parathą po lunch w biurze — nasz cel jest prosty: żeby indyjskie jedzenie stało się częścią Twojego dnia.",
      ],
      motto: "Realne jedzenie. Lepsze jutro.",
      values: ["Tradycja", "Świeżość", "Technologia", "Ty"],
    },
    contactPage: {
      heroTitle: "Kontakt",
      heroSub: "Chętnie Cię usłyszymy.",
      visit: "Odwiedź nas",
      emailUs: "Napisz do nas",
      callUs: "Zadzwoń",
      followUs: "Obserwuj",
      form: {
        title: "Wyślij wiadomość",
        name: "Imię i nazwisko *",
        email: "E-mail *",
        company: "Firma",
        phone: "Telefon",
        date: "Data wydarzenia",
        guests: "Liczba gości",
        budget: "Budżet",
        budgets: ["Poniżej 1 000 zł", "1 000–3 000 zł", "3 000–10 000 zł", "10 000+ zł"],
        message: "Wiadomość *",
        send: "Wyślij wiadomość",
        sending: "Wysyłanie…",
        success: "Wysłano. Odpowiadamy w ciągu 24 godzin.",
        error: "Nie udało się wysłać — napisz na info@thekurkuma.pl",
      },
      touchTitle: "Napisz w sprawie",
      touch: ["Zamówień firmowych", "Wycen cateringu", "Pytań ogólnych"],
      mapTitle: "Warszawa",
    },
  },
};

// Opening countdown target — confirmed by user: 1-Dec-2026
export const OPENING_DATE = "2026-12-01T09:00:00+01:00";

export const SOCIALS = {
  instagram: "https://www.instagram.com/thekurkuma436/",
  facebook: "https://www.facebook.com/profile.php?id=61594570476007",
  linkedin: "https://www.linkedin.com/company/107902480/",
  igHandle: "@thekurkuma436",
};
